<mat-chip class="cass-id-chip" [ngClass]="{ 'clickable': customer && !customer.agency }" (click)="openAdvertiser()" title="{{ getText() }}">
	{{ getText() }}
</mat-chip>
